export const TEST_BUILDER_COUNT_OPTIONS = [1, 2, 3];
export const DEFAULT_MULTIPLE_CHOICE_QUESTIONS_PER_TEST = 5;
export const DEFAULT_REFERENCE_TEST_ITEMS_PER_TEST = 8;
export const MIN_REFERENCE_TEST_ITEMS = 4;

// Single source of truth for the model used by every multiple-choice question
// generation path (studio builder, document extraction, paste-to-quiz). Keep
// all paths on the same model so question quality is consistent. This must be a
// modelType understood by runAIModel (see lib/llms/models.js).
export const MCQ_GENERATION_MODEL_TYPE = "claude";
